/** The three states a user sees for a track they made. Every pipeline status
 * before ready is "preparing"; failed is "attention". */
export type TrackState = "ready" | "preparing" | "attention";

export const TRACK_STATE_LABEL = {
  ready: "Ready to sing",
  preparing: "Preparing",
  attention: "Needs attention",
} satisfies Record<TrackState, string>;

export function trackState(processingStatus: string): TrackState {
  if (processingStatus === "ready") return "ready";
  if (processingStatus === "failed") return "attention";
  return "preparing";
}
